import React from "react";
import "./PolicyStudioActionButton.css";

export interface PolicyStudioActionButtonProps {
  label: string;
  variant?: "primary" | "secondary" | "tertiary";
  onClick?: () => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

export const PolicyStudioActionButton: React.FC<
  PolicyStudioActionButtonProps
> = ({ label, variant = "secondary", onClick, onMouseDown, disabled }) => {
  return (
    <button
      className={`policy-studio-action-button policy-studio-action-button-${variant} ${disabled ? "disabled" : ""}`}
      onClick={disabled ? undefined : onClick}
      onMouseDown={disabled ? undefined : onMouseDown}>
      {label}
    </button>
  );
};

export default PolicyStudioActionButton;
